import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const successNotify = (message) => toast.success(message, {
  autoClose: 1000
});
export const errorNotify = (message) => toast.error(message, {
  autoClose: 1000
});